import { createAction, props } from '@ngrx/store';
import { Period } from '@shared/types/period';
import { QuoteType } from '@shared/types/quote-type';

export const createQuotes = createAction(
  '[Cart] Create Quotes',
  props<{
    quote_type: QuoteType;
    periods: Period[];
    send_email: boolean;
    reference?: string;
    skip_external_creation?: boolean;
    custom_expiration_date?: string;
    end_user_quote_email_address?: string[];
    reseller_quote_email_address?: string[];
    opportunity_id?: number;
    preferred_period?: Period;
  }>(),
);

export const createQuotesSuccess = createAction(
  '[Cart] Create Quotes Success',
  props<{ quote_ids: number[]; opportunity_id?: number; quote_type: QuoteType; existing_opportunity?: boolean }>(),
);

export const createQuotesFailure = createAction('[Cart] Create Quotes Failure', props<{ error: any }>());
